import { DiscountContent } from '@us-registration/util-models';

export const discounts: { [key: string]: DiscountContent } = {
  D50P2M: {
    banner:
      'Online exclusive offer – get {{ percentage }}% for first {{ term }} months! Limited time only',
    subscription: 'Offer - {{ percentage }}% off for first {{ term }} months',
  },
  D50P4M: {
    banner:
      'Online exclusive offer – get {{ percentage }}% for first {{ term }} months! Limited time only',
    subscription: 'Offer - {{ percentage }}% off for first {{ term }} months',
  },
  D50P6M: {
    banner:
      'Online exclusive offer – get {{ percentage }}% for first {{ term }} months! Limited time only',
    subscription: 'Offer - {{ percentage }}% off for first {{ term }} months',
  },
  D20P6M: {
    banner:
      'Online exclusive offer – get {{ percentage }}% for first {{ term }} months! Limited time only',
    subscription: 'Offer - {{ percentage }}% off for first {{ term }} months',
  },
  D10PTM: {
    banner:
      'Online exclusive offer – get Appliance Care with {{ percentage }}% off! Limited time only',
    subscription: 'Offer - {{ percentage }}% off for first {{ term }} months',
  },
  D15PTM: {
    banner:
      'Online exclusive offer – get Appliance Care with {{ percentage }}% off! Limited time only',
    subscription: 'Offer - {{ percentage }}% off',
  },
  D20PTM: {
    banner:
      'Online exclusive offer – get Appliance Care with {{ percentage }}% off! Limited time only',
    subscription: 'Offer - {{ percentage }}% off for first {{ term }} months',
  },
};
